<template>
  <div id="app">
    <v-app id="inspire">
      <v-layout id="layout">
        <v-row  class="hidden-sm-and-down mainColor">
          <v-col
            cols="12"
            class="mt-11 text-center text-sm-center text-md-center text-xl-center"
          >
          <a :href="clientData.siteLink" target="_blank">
            <img
              class=""
              height="80px"
              :src="clientData.logo"
              alt="Logo"
            />
            </a>
          </v-col>
          <v-col
            cols="12"
            xl="12"
            class="display-2 text-center text-sm-center"
            :style="{'color':clientData.mainColor}"
          >
            Employee Retention Tax Credit</v-col
          >
          <v-col
            cols="12"
            xl="12"
            class="text-center text-sm-center"
            style="font-size: 1.5rem; font-weight: bold"
            :style="{'color':clientData.secondaryColor}"
          >
            WORTH UP TO $26,000 PER W2 EMPLOYEE!
          </v-col>
          <v-col
            cols="12"
            md="12"
            lg="12"
            xl="12"
            class="mt-8 pt-6 text-center text-md-center text-xl-center secondaryColor"
          >
            <a @click="$vuetify.goTo('#claim')" class="mt-10">
              <button class="button btnColor" >Begin your ERTC claim</button>
            </a>
            <a @click="$vuetify.goTo('#faqs')" class="mt-10">
              <button class="button btnColor">FAQs</button>
            </a>
            <a @click="$vuetify.goTo('#contact')" class="mt-10">
              <button class="button btnColor">Contact</button>
            </a>
          </v-col>
        </v-row>

        <v-app-bar color="#4a2a0e" dark class="hidden-md-and-up" height="80">
          <a :href="clientData.siteLink" target="_blank">
          <img
            class="ml-3"
            height="35px"
            :src="clientData.logo"
            alt="Logo"
          />
          </a>

          <v-spacer></v-spacer>

          <v-app-bar-nav-icon
            class="mr-3"
            @click.stop="drawer = !drawer"
          ></v-app-bar-nav-icon>
        </v-app-bar>

        <v-navigation-drawer v-model="drawer" absolute temporary>
          <v-list nav dense>
            <v-list-item-group
              v-model="group"
              active-class="deep-purple--text text--accent-4"
            >
              <v-list-item class="text-start">
                <a @click="$vuetify.goTo('#claim')" class="mt-10">
                  <button class="button text-start">
                    Begin your ERTC claim
                  </button>
                </a>
              </v-list-item>

              <v-list-item>
                <a @click="$vuetify.goTo('#faqs')" class="mt-10">
                  <button class="button">FAQs</button>
                </a>
              </v-list-item>

              <v-list-item>
                <a @click="$vuetify.goTo('#contact')" class="mt-10">
                  <button class="button">Contact</button>
                </a>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>

        <v-col
          cols="12"
          class="d-flex justify-center bg mt-0 mt-md-3 mt-lg-3 mt-xl-3"
        >
          <v-col cols="12" xl="8" class="justify-center mt-6">
            <v-row class="d-flex justify-center mt-16">
              <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="d-flex justify-center">
                <v-card
                  class="pa-0 mr-sm-11 mr-md-0"
                  elevation="0"
                  style="background: transparent"
                >
                  <v-card-text
                    style="
                      opacity: 1;
                      font-size: 20px;
                      font-weight: bold;
                      color: #3c4e6f;
                      padding: 0;
                      line-height: 27px;
                      text-align: center;
                    "
                    :class="{
                      'ml-6': $vuetify.breakpoint.smAndDown,
                      'pr-6': $vuetify.breakpoint.smAndDown,
                    }"
                  >
                    The Employee Retention Tax Credit (ERTC) program is one of
                    the most misunderstood elements of the pandemic relief
                    package passed by Congress.
                    <span
                    :style="{'background-color': clientData.secondaryColor, 'color': 'white', 'margin-bottom': 30 + 'px'}"
                      :class="{
                        'ml-6': $vuetify.breakpoint.smAndDown,
                        'mr-16': $vuetify.breakpoint.smAndDown,
                      }"
                      >Your business is likely eligible and should immediately
                      explore the ERTC before funds run out.</span
                    >
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col
                class="vimeo-player d-flex justify-center"
                cols="12"
                sm="12"
                md="7"
                lg="7"
                xl="7"
              >
                <video width="100%" height="100%" controls poster="../../client/placeholdeer.jpg">
                  <source :src="clientData.client_video_source" type="video/webm">
                  <source :src="clientData.client_video_source" type="video/mp4">
                </video>
              </v-col>
            </v-row>
          </v-col>
        </v-col>

        <v-col cols="12" class="mainColor">
          <v-container class="d-flex justify-center">
            <v-col cols="12" xl="8">
              <v-row class="d-flex justify-space-around">
                <v-col
                  v-for="(card, index) in cards"
                  :key="`card -${index}`"
                  cols="12"
                  sm="12"
                  xs="12"
                  md="4"
                  lg="3"
                  xl="3"
                >
                  <v-card
                    class="mr-lg-5 rounded"
                    tile
                    height="100%"
                    elevation="8"
                    style="border: 1.5px solid white"
                  >
                  
                    <v-card-title
                      style="word-break: keep-all"
                      class="card-head d-sm-flex justify-center p-sm-10 "
                    >
                      {{ card.header }}
                      <div class="arrow-down mr-13 mt-sm-n2 mt-md-7">

                      </div>
                    </v-card-title>
                   
                    <v-card-text
                      style="color: #4b5b79; margin-top: 35px; font-weight: 600"
                      class="text-center px-5"
                    >
                      {{ card.body }}
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-container>
          <div id="scrollTarget"></div>
        </v-col>
        <template class="block-color">
          <div
            style="text-align: center; width: 100%; color: #9d5718"
            class="mt-5"
          >
            <v-row justify="center" class="my-16" v-if="isRequestPosted">
              <v-col cols="10" md="6" lg="7" xl="7" class="my-10">
                <h2 style="color: black">
                  Thank you for engaging <span class="text-no-wrap primary white--text">{{ clientData.attorney_firm }}</span> and the tax law firm of Dallas Anthony & Jeffords, PLLC to assist in the Employee Retention Tax Credit analysis and calculation for your business.
                  Your next step is to complete the Financial Checklist that has been sent to the address you provided. Please note that the email will come from Patriot Data Processing.
                  Please direct any questions you may have to <span class="text-no-wrap primary white--text">{{ clientData.attorney_name }}</span> at <span class="text-no-wrap primary white--text">{{ clientData.attorney_email }}</span>
                  <br>
                  <span class="text-h4">Thank you!</span>
                </h2>
              </v-col>
            </v-row>
            <h1 v-if="!isRequestPosted" class="mb-4" id="claim">
              Begin your ERTC Claim NOW!
            </h1>
            <h3 v-if="!isRequestPosted" class="mb-4" style="color: #3c4e6f">
              Engage our firm to begin working on your ERTC claim by completing the form below. <br/> All fields are required. Please read carefully. You are entering into a binding legal agreement!

            </h3>
            <v-form v-if="!isRequestPosted" v-on:submit.prevent="submitForm">
              <v-container>
                <input
                  v-model="form.entity"
                  type="hidden"
                  name="entity"
                />
                <v-row class="d-flex justify-center ml-2 mr-2">
                  <v-col cols="12" lg="2" xl="2" md="2" xs="2">
                    <v-select
                      :items="salutationItems"
                      label="Salutation"
                      v-model="form.contact_salutation"
                      outlined
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" lg="2" xl="2" md="2">
                    <v-text-field
                      outlined
                      v-model="form.contact_first"
                      label="First Name"
                      color="blue darken-2"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="2" xl="2" md="2">
                    <v-text-field
                      outlined
                      v-model="form.contact_last"
                      label="Last Name"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2" lg="2" xl="2">
                    <v-text-field
                      outlined
                      v-model="form.contact_title"
                      label="Title"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xl="8" lg="8" md="8" style="padding: 0">
                    <v-row class="d-flex justify-center" style="margin: 0">
                      <v-col cols="12" md="6">
                        <v-text-field
                          outlined
                          v-model="form.contact_email"
                          :error-messages="contact_emailErrors"
                          @input="$v.form.contact_email.$touch()"
                          @blur="$v.form.contact_email.$touch()"
                          label="Email"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" xl="6" md="6">
                        <v-text-field
                          outlined
                          v-model="form.contact_phone"
                          label="Phone"
                          :rules="[rules.required, ...phoneRules]"
                          :maxLength="10" 
                          v-restrict.number.decimal
                          prefix="+"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>

                  <!-- 
                  <v-col cols="12" lg="8" xl="8" md="8">
                    <v-text-field
                      
                      outlined
                      v-model="form.contact_email"
                      :error-messages="contact_emailErrors"
                      @input="$v.form.contact_email.$touch()"
                      @blur="$v.form.contact_email.$touch()"
                      label="Email"
                      required
                    ></v-text-field>
                  </v-col> -->
                  <v-col cols="12" xl="8" lg="8" md="8" style="padding: 0">
                    <v-row cols="12" md="6" lg="6" xl="6" style="margin: 0">
                      <v-col>
                        <v-text-field
                          outlined
                          v-model="form.trade_name"
                          label="Business Name"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="6" xl="6" md="6">
                        <v-text-field
                          outlined
                          :error-messages="einErrors"
                          @input="$v.form.ein.$touch()"
                          @blur="$v.form.ein.$touch()"
                          v-model="form.ein"
                          label="Business Federal Tax ID"
                          required
                          :maxLength="10"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="8" xl="8" md="8" xs="12">
                    <v-text-field
                      outlined
                      v-model="form.street"
                      label="Street"
                      :rules="[rules.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xl="8" lg="8" md="8" style="padding: 0">
                    <v-row class="d-flex justify-center" style="margin: 0">
                      <v-col cols="12" xl="4" lg="4" md="4">
                        <v-text-field
                          outlined
                          v-model="form.city"
                          label="City"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" xl="4" lg="4" md="4">
                        <v-select
                          :items="stateItems"
                          outlined
                          v-model="form.state"
                          label="State"
                          :rules="[rules.required]"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" xl="4" lg="4" md="4">
                        <v-text-field
                          outlined
                          v-model="form.zip"
                          label="Zip"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" lg="8" xl="8" md="8" style="padding: 0">
                    <v-row class="d-flex justify-center" style="margin: 0">
                    </v-row>
                  </v-col>

                  <v-col cols="12" lg="8" xl="8" md="8">
                    <template>
                      <div
                        style="
                          border: 1.5px solid #a4a4a4;
                          padding: 4px;
                          border-radius: 0.3rem;
                        "
                      >
                        <v-container
                          id="scroll-target"
                          style="max-height: 400px"
                          class="overflow-y-auto"
                        >
                          <v-row
                            v-scroll:#scroll-target="onScroll"
                            class="text-start"
                            style="height: 500px"
                          >
                            <p style="color: black">
                              CLIENT SERVICES AGREEMENT<br /><br />
                              {{ termsAndConditions }}
                              {{ currentDate }} (“Effective Date”) between
                              Dallas, Anthony &Jeffords, PLLC, (“DA&J”) 213
                              Katerine Drive, Flowood, Mississippi 39232, and
                              the undersigned party (“Client”). Client and DA&J
                              is referred to herein from time to time
                              individually as “Party”and collectively as
                              “Parties.”DA&J will work with Client to:<br /><br />
                              1. Identify qualified locations and employees for
                              Employee Retention Tax Credit (“ERTC”).<br /><br />2.
                              Gather applicable information and conduct the
                              analysis necessary to determine the qualified work
                              locations and employees eligible for the ERTC.<br /><br />3.
                              Calculate credits based upon data received and
                              reviewed.<br /><br />4. Prepare and deliver credit
                              package to client with any applicable supporting
                              schedules for any Credits that are available
                              during the term of this agreement.<br /><br />5.
                              This Agreement shall be for calculation of the
                              ERTC and delivery of the necessary documents to
                              the Internal Revenue Service to apply for such
                              federal tax credits. This Agreement shall remain
                              in force for one (1) year from the effective
                              date.<br /><br />6. Either party may terminate
                              this Agreement if the other party has materially
                              breached the Agreement, provided that the party
                              claiming breach must give the other party at least
                              30 days prior written notice to cure the breach
                              before terminating this Agreement. Upon
                              termination, Client shall be obligated to
                              immediately pay all invoices on completed work and
                              for work in progress upon receipt of the invoice.
                              This paragraph shall survive the termination of
                              this Agreement.<br /><br />7. DA&J is not a tax
                              preparer and disclaims any and all responsibility
                              for preparation of Client’s federal and/or state
                              tax returns except those documents filed in
                              connection with the tax credits related to the
                              services described herein.<br /><br />8. Client
                              shall pay DA&J a 20% contingency fee based on the
                              actual amount received for tax credits related to
                              the services described herein.<br /><br />9. The
                              contingency fee does not apply to any interest
                              calculated by the IRS and applied to the credit
                              amounts.<br /><br />10. Client will be invoiced
                              when the tax credit package is delivered to the
                              Internal Revenue Service.Invoices are due when the
                              client receives payment from the Internal Revenue
                              Service. This paragraph shall survive termination
                              of this Agreement. DA&J stands behind its work
                              and will fully defend the client at no additional
                              fee in the event of an IRS audit pertaining to
                              theEmployee Retention Tax Credits prepared and
                              certified by DA&J.<br /><br />11. All Client Data
                              provided to DA&J shall be deemed Confidential
                              Information.<br /><br />12. Any notice required or
                              permitted under this Agreement will be deemed to
                              have been given when personally delivered,
                              deposited with a nationally recognized courier, or
                              sent by registered or certified US mail, return
                              receipt requested, postage prepaid, to the other
                              Party at the address set forth at the beginning of
                              this Agreement.<br /><br />13. This Agreement
                              shall be governed by the laws of the State of
                              Mississippi. Disputes will be settled by
                              arbitration under the Rules of the American
                              Arbitration Association.IN WITNESS WHEREOF, the
                              Parties have caused this Agreement to be executed
                              as of the date first written above.
                            </p>
                          </v-row>
                        </v-container>
                      </div>
                    </template>
                  </v-col>
                  <v-col class="d-flex justify-center" cols="12">
                    <v-checkbox
                      v-model="form.checkbox"
                      label="I agree to the terms and conditions"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
              <v-btn
                :disabled="$v.form.$invalid"
                type="submit"
                class="mb-10"
                color="#F6911E"
                @click="$vuetify.goTo('#scrollTarget')"
              >
                <span style="color: white"> I agree</span>
              </v-btn>
            </v-form>
          </div>
          <div class="solid-background" id="contact">
            <h2 class="mb-2">
              For more information contact<br />
              attorney {{clientData.attorney_name}}.
            </h2>
            <h2>{{clientData.attorney_number}}<br />{{clientData.attorney_email}}</h2>
          </div>
          <v-row justify="center">
            <v-col
              cols="12"
              xl="8"
              lg="8"
              md="8"
              sm="10"
              xs="10"
              style="text-align: center; margin-bottom: 16rem"
            >
              <h1 id="faqs" class="mb-5 mt-5">Frequently Asked Questions</h1>
              <v-col
                v-for="(question, index) in questions"
                :key="`question -${index}`"
              >
                <v-card
                  class="d-md-flex"
                  elevation="0"
                  style="text-align: left"
                >
                  <img
                    height="200"
                    style="margin-right: 15px"
                    :src="getImgUrl(question.src)"
                    alt="asd"
                  />
                  <div>
                    <h2 class="faq-head">
                      {{ question.header }}
                    </h2>
                    <p class="faq-body">
                      {{ question.body }}
                    </p>
                  </div>
                </v-card>
              </v-col>
            </v-col>
          </v-row>
          <div style="width: 100%; text-align: center">
            <v-divider> </v-divider>

            <p>&copy; {{ new Date().getFullYear() }} All Rights Reserved.</p>
          </div>
        </template>
        <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
        >{{text}}</v-snackbar>
      </v-layout>
    </v-app>
  </div>
</template>

<script>
import { email, required, helpers } from "vuelidate/lib/validators";
import axios from "../../plugins/axios";
import clientData from "@/client/client";

const einValidator = helpers.regex("einValidator", /[0-9]{2}-[0-9]{7}/);
export default {
  created() {
    this.form.entity = clientData.client_entity
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0");
    let yyyy = today.getFullYear();
    if (mm < 10) {
      mm = mm[1];
    }
    if (dd < 10) {
      dd = dd[1];
    }
    today = mm + "/" + dd + "/" + yyyy;
    this.currentDate = today;
  },
  name: "LandingPage",
  watch: {
    group() {
      this.drawer = false;
    },
  },
  data() {
    return {
      snackbar: false,
      text: 'Thank you for selecting Capital Preservation Services to assist you with your Employee Retention Tax Credits. Please check your email for instructions on the next steps required to claim these credits.',
      timeout: 4000,
      snackbarColor: 'green',
      currentDate: '',
      form: {
        contact_salutation: "",
        contact_first: "",
        contact_last: "",
        contact_email: "",
        trade_name: "",
        ein: "",
        entity: "5",
        city: "",
        state: "",
        zip: "",
        street: "",
        contact_title: "",
        contact_phone: "",
        isTermsValid: false,
        currentDate: "",
        checkbox: false
      },
      clientData: clientData,
      date: new Date(),
      offset: 0,
      drawer: false,
      group: null,
      termsAndConditions: "This Agreement dated ",
      termsAndConditionsSecond:
        "(“Effective Date”) between Dallas, Anthony &Jeffords, PLLC, (“DA&J”) 213 Katerine Drive, Flowood, Mississippi 39232, and the undersignedparty (“Client”). Client and DA&J is referred to herein from time to time individually as “Party”and collectively as “Parties.”DA&J will work with Client to:1. Identify qualified locations and employees for Employee Retention Tax Credit (“ERTC”).  2. Gather applicable information and conduct the analysis necessary to determine the qualifiedwork locations and employees eligible for the ERTC.  3. Calculate credits based upon data received and reviewed.  4. Prepare and deliver credit package to client with any applicable supporting schedules for any Credits that are available during the term of this agreement.  5. This Agreement shall be for calculation of the ERTC and delivery of the necessary documentsto the Internal Revenue Service to apply for such federal tax credits. This Agreement shallremain in force for one (1) year from the effective date.  6. Either party may terminate this Agreement if the other party has materially breached the Agreement, provided that the party claiming breach must give the other party at least 30 daysprior written notice to cure the breach before terminating this Agreement. Upon termination,Client shall be obligated to immediately pay all invoices on completed work and for workin progress upon receipt of the invoice. This paragraph shall survive the termination of this Agreement.  7. DA&J is not a tax preparer and disclaims any and all responsibility for preparation of Client’s federal and/or state tax returns except those documents filed in connection with the tax creditsrelated to the services described herein.  8. Client shall pay DA&J a 20% contingency fee based on the actual amount received for tax credits related to the services described herein.  9. The contingency fee does not apply to any interest calculated by the IRS and applied to thecredit amounts.  10. Client will be invoiced when the tax credit package is delivered to the Internal Revenue Service.Invoices are due when the client receives payment from the Internal Revenue Service. Thisparagraph shall survive termination of this Agreement. DA&J stands behind its work andwill fully defend the client at no additional fee in the event of an IRS audit pertaining to theEmployee Retention Tax Credits prepared and certified by DA&J.  11. All Client Data provided to DA&J shall be deemed Confidential Information.  12. Any notice required or permitted under this Agreement will be deemed to have been givenwhen personally delivered, deposited with a nationally recognized courier, or sent by registeredor certified US mail, return receipt requested, postage prepaid, to the other Party at the addressset forth at the beginning of this Agreement.13. This Agreement shall be governed by the laws of the State of Mississippi. Disputes will be settledby arbitration under the Rules of the American Arbitration Association.IN WITNESS WHEREOF, the Parties have caused this Agreement to be executed as of the datefirst written above.",
      salutationItems: ["Mr.", "Ms.", "Mrs.", "Dr."],
      stateItems: [
        "AL",
        "AK",
        "AS",
        "AZ",
        "AR",
        "CA",
        "CO",
        "CT",
        "DE",
        "DC",
        "FM",
        "FL",
        "GA",
        "GU",
        "HI",
        "ID",
        "IL",
        "IN",
        "IA",
        "KS",
        "KY",
        "LA",
        "ME",
        "MH",
        "MD",
        "MA",
        "MI",
        "MN",
        "MS",
        "MO",
        "MT",
        "NE",
        "NV",
        "NH",
        "NJ",
        "NM",
        "NY",
        "NC",
        "ND",
        "MP",
        "OH",
        "OK",
        "OR",
        "PW",
        "PA",
        "PR",
        "RI",
        "SC",
        "SD",
        "TN",
        "TX",
        "UT",
        "VT",
        "VI",
        "VA",
        "WA",
        "WV",
        "WI",
        "WY",
      ],
      isRequestPosted: false,
      dialog: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
      cards: [
        {
          header: "How much is the ERTC worth to my business?",
          body: "The ERTC can be worth up to $26,000 per W2 employee in your business. ERTC funds are NOT a loan and do NOT have to be repaid. There are no stipulations on how a business may use ERTC funds once received. Though labeled a “tax credit” the ERTC is distributed to the business as a direct payment from the IRS.",
        },
        {
          header: "How do I qualify for the ERTC?",
          body: "The ERTC is a federal stimulus program designed for businesses that operated during the pandemic and maintained W2 employees. A business may qualify for the ERTC by showing EITHER a requisite drop in gross revenues OR a “greater than nominal impact” due to government mandates and restrictions. A business may receive BOTH the ERTC and PPP funds.",
        },
        {
          header: "How do I apply for and collect the ERTC?",
          body: "A detailed analysis of your business will be conducted by tax attorneys specializing in the ERTC. Application documents will be prepared and filed with the IRS. The IRS will take approximately 6-8 months to process your ERTC claim and will mail your credit checks directly to your business.",
        },
      ],
      questions: [
        {
          header:
            "My business made money during the pandemic. Can I still qualify?",
          body: "Yes. While a reduction in revenue is one mechanism of qualifying for the ERTC, it is not the only mechanism. The Nominal Impact Test may also be used, and this test incorporates more qualitative factors such as supply chain disruption related to government mandates.",
          src: "Layer-8.webp",
        },
        {
          header: "Can I access the ERTC if I received PPP loans?",
          body: "Yes. Receipt of PPP loans does not disqualify a business from receiving the ERTC. However, all PPP funds that a business did receive, and applied to payroll expenses, must be properly accounted for prior to calculating the ERTC. This step is handled by tax attorneys as part of their detailed analysis of your business.",
          src: "Layer-9.webp",
        },
        {
          header:
            "What if my CPA already told me I don’t qualify for the ERTC?",
          body: "When a CPA deems a business to “not qualify” for the ERTC, it is almost always due to the CPA’s analysis of the Revenue Reduction Test. CPA’s, broadly speaking, have been less than enthusiastic to analyze businesses under the Nominal Impact Test and have left such analysis to tax attorneys specializing in the ERTC.",
          src: "Layer-7.webp",
        },
        {
          header: "Is the ERTC specific to any industry?",
          body: "No. The ERTC is intended for businesses that operated during the pandemic and maintained W2 employees. Only businesses that are directly related to federal or state government are ineligible. Private businesses from any industry, including non-profits, may qualify.",
          src: "Layer-6.webp",
        },
        {
          header: "Am I required to have a certain number of employees?",
          body: "There are no minimum number of employees required to access the ERTC. However, the maximum number of employees a business may possess is 100 in 2020, and 500 in 2021.",
          src: "Layer-5.webp",
        },
        {
          header: "Why haven’t I heard about the ERTC?",
          body: "The ERTC has evolved significantly since its inception and this evolution has resulted in confusion and misunderstanding of the program. Without following the details contained in hundreds of pages of the CARES Act, along with subsequent executive orders by both President Trump and President Biden, the opportunity in the ERTC can be easily missed.",
          src: "Layer-4.webp",
        },
        {
          header: "Are there risks involved?",
          body: "All of our work is performed on a contingency fee basis and you pay nothing until you receive your ERTC checks from the IRS. In addition, in the unlikely event of a subsequent IRS audit challenging our legal determination of your eligibility, our tax attorneys will provide a full defense of your ERTC claim at no additional fee.",
          src: "Layer-10.webp",
        },
      ],
      phoneRules: [
       v => !!v || 'Required.',
       v => (v || '').length <= 10 || 'Max 10 characters.',
       v => Number.isInteger(Number(v)) || "The value must be a number."
      ],
    };
  },
  validations: {
    form: {
      contact_email: {
        required,
        email,
      },
      ein: {
        required,
        einValidator,
      },
      contact_salutation: {
        required,
      },
      street: {
        required,
      },
      zip: {
        required,
      },
      state: {
        required,
      },
      contact_first: {
        required,
      },
      contact_last: {
        required,
      },
      contact_title: {
        required,
      },
      contact_phone: {
        required,
      },
      checkbox: {
        checked: (value) => value === true,
      },
      // isTermsValid: {
      //   checked: (value) => value === true,
      // },
    },
  },
  computed: {
    contact_emailErrors() {
      const errors = [];
      if (!this.$v.form.contact_email.$dirty) return errors;
      !this.$v.form.contact_email.email &&
        errors.push("Please add a valid email.");
      !this.$v.form.contact_email.required &&
        errors.push("Email Field is required.");
      return errors;
    },
    einErrors() {
      const errors = [];
      if (!this.$v.form.ein.$dirty) return errors;
      !this.$v.form.ein.einValidator &&
        errors.push(
          "Your EIN format is wrong. Ex: 00-0000000 (Use Digits only)"
        );
      !this.$v.form.ein.required && errors.push("EIN is required.");
      return errors;
    },
    // contact_salutationErrors() {
    // const errors = []
    // if (!this.$v.form.contact_salutation.$dirty) return errors

    // !this.$v.form.contact_salutation.required && errors.push('Title is required.')
    // return errors
    // },
  },
  methods: {
    onScroll(e) {
      const clientHeight = e.target.clientHeight;
      const target = e.target.scrollHeight;
      this.offset = e.target.scrollTop;
      if (this.offset + clientHeight == target) {
        this.form.isTermsValid = true;
      } else {
        this.form.isTermsValid = null;
      }
    },
    submitForm() {
      this.form.client_agreement_body = `CLIENT SERVICES AGREEMENT ${ this.currentDate } ("Effective Date") between Dallas, Anthony & Jeffords, PLLC, ("DA&J") 213 Katerine Drive, Flowood, Mississippi 39232, and the undersigned party ("Client"). Client and DA&J is referred to herein from time to time individually as "Party"and collectively as "Parties."DA&J will work with Client to: 1. Identify qualified locations and employees for Employee Retention Tax Credit ("ERTC").2. Gather applicable information and conduct the analysis necessary to determine the qualified work locations and employees eligible for the ERTC.3. Calculate credits based upon data received and reviewed.4. Prepare and deliver credit package to client with any applicable supporting schedules for any Credits that are available during the term of this agreement.5. This Agreement shall be for calculation of the ERTC and delivery of the necessary documents to the Internal Revenue Service to apply for such federal tax credits. This Agreement shall remain in force for one (1) year from the effective date.6. Either party may terminate this Agreement if the other party has materially breached the Agreement, provided that the party claiming breach must give the other party at least 30 days prior written notice to cure the breach before terminating this Agreement. Upon termination, Client shall be obligated to immediately pay all invoices on completed work and for work in progress upon receipt of the invoice. This paragraph shall survive the termination of this Agreement.7. DA&J is not a tax preparer and disclaims any and all responsibility for preparation of Client’s federal and/or state tax returns except those documents filed in connection with the tax credits related to the services described herein.8. Client shall pay DA&J a 20% contingency fee based on the actual amount received for tax credits related to the services described herein.9. The contingency fee does not apply to any interest calculated by the IRS and applied to the credit amounts.10. Client will be invoiced when the tax credit package is delivered to the Internal Revenue Service.Invoices are due when the client receives payment from the Internal Revenue Service. This paragraph shall survive termination of this Agreement. DA&J stands behind its work and will fully defend the client at no additional fee in the event of an IRS audit pertaining to theEmployee Retention Tax Credits prepared and certified by DA&J.11. All Client Data provided to DA&J shall be deemed Confidential Information.12. Any notice required or permitted under this Agreement will be deemed to have been given when personally delivered, deposited with a nationally recognized courier, or sent by registered or certified US mail, return receipt requested, postage prepaid, to the other Party at the address set forth at the beginning of this Agreement.13. This Agreement shall be governed by the laws of the State of Mississippi. Disputes will be settled by arbitration under the Rules of the American Arbitration Association.IN WITNESS WHEREOF, the Parties have caused this Agreement to be executed as of the date first written above.`

      axios.post("signups", this.form).then((res) => {
          this.isRequestPosted = true;
          this.snackbar = true
          this.text = `Thank you for selecting ${clientData.attorney_firm} to assist you with your Employee Retention Tax Credits. Please check your email for instructions on the next steps required to claim these credits.`
          this.snackbarColor = 'green'
		  }).catch(error => {
          this.snackbar = true
          this.text = error.response.data.error
          this.snackbarColor = 'red'
			});
    },
    getImgUrl(pic) {
      return require("../../assets/ertc-images/" + pic);
    },
  },
};
</script>

<style scoped src="../../client/styles.css">
</style>
